import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import api from "../api/axios";

export default function ResetPasswordPage() {
  const { t } = useTranslation<"translation">();
  const { token } = useParams();
  const nav = useNavigate();

  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsg("");

    if (pwd !== confirm) {
      setMsg(t<string>("resetPassword.error.noMatch"));
      return;
    }

    try {
      await api.post("/auth/reset-password", { token, newPwd: pwd, confirm });
      setMsg(t<string>("resetPassword.success"));
      setTimeout(() => nav("/login", { replace: true }), 2000);
    } catch (err: any) {
      setMsg(err.response?.data?.message ?? t("resetPassword.error.generic"));
    }
  };

  return (
    <div className="h-screen flex items-center justify-center">
      <form onSubmit={submit} className="border p-6 rounded w-full max-w-sm space-y-3">
        <div className="flex justify-between items-start">
          <h2 className="text-lg font-semibold">{t("resetPassword.title")}</h2>
        </div>

        <input
          className="w-full border p-2 rounded"
          type="password"
          placeholder={t<string>("resetPassword.fields.new")}
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
        />
        <input
          className="w-full border p-2 rounded"
          type="password"
          placeholder={t<string>("resetPassword.fields.confirm")}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />

        {msg && <p className="text-red-500 text-sm text-center whitespace-pre-line">{msg}</p>}

        <button
          type="submit"
          className="w-full bg-blue-600 hover:bg-blue-700 text-white p-2 rounded"
        >
          {t("resetPassword.btn")}
        </button>
      </form>
    </div>
  );
}
